import type { RouteObject as AdminRouteObject } from "react-router-dom";
import type { AdminDashboardDependencies } from "../composition/create-admin-dashboard-dependencies";
import { ConversationHistoryScreen } from "../../features/conversations/conversation-history-screen";

export function createConversationsRoute(dependencies: AdminDashboardDependencies): AdminRouteObject {
  return {
    path: "conversations",
    element: <ConversationHistoryScreen dependencies={dependencies} />,
  };
}
